var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blocksReady)?_c('BlockLoader',{ref:"blockLoader",staticStyle:{"width":"100%"},attrs:{"blockContent":_vm.navigationBlocks}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }